<template>
<b-form-group :id="`${id}_Group`" :label="labelText" :label-for="id" :class="{required: isRequired, 'is-invalid': isValid != null && !isValid}"
    :description="description">
    <template slot="label"><span class="label">{{labelText}}</span><i v-if="helpText" class="fas fa-question-circle help-icon" v-b-popover.hover.right.html="helpText" :title="helpTitle"></i></template>
  <vue-datepicker-local :value="value" @input="input" clearable :local="local" format="MM/DD/YYYY" :disabled-date="disabledDate" :inputClass="inputClass" :required="isRequired" :aria-describedby="`${id}_Feedback`" :placeholder="placeholder"/>
  <b-form-invalid-feedback :id="`${id}_Feedback`">
    <slot name="feedback"></slot>
  </b-form-invalid-feedback>
</b-form-group>
</template>

<script>
import moment from "moment";
import VueDatepickerLocal from "vue-datepicker-local";
import helpers from "../helpers";

export default {
  mixins: [helpers],
  components: { VueDatepickerLocal },
  props: {
    disableFutureDates: {
      type: Boolean,
      default: true
    },
    startingFutureDate: {
      type: [Date, String],
      default: () => new Date()
    }
  },
  data: function() {
    return {
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm"
      },
      disabledDate(date) {
        if (
          this.$parent.$parent.disableFutureDates &&
          moment(date).isAfter(this.$parent.$parent.startingFutureDate)
        )
          return true;
        return false;
      }
    };
  },
  computed: {
    inputClass() {
      var cssClass = "";
      if (this.isValid != null) {
        if (!this.isValid) {
          cssClass = "is-invalid";
        } else {
          cssClass = "is-valid";
        }
      }
      return "form-control " + cssClass;
    }
  }
};
</script>

<style>
</style>
